import React from "react";
import { Modal, Typography, Avatar, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import moment from "moment";
import "./VarianceHistoryModal.less";

const { Text } = Typography;

const VarianceHistoryModal = ({
  visible,
  onClose,
  history = [],
  loading = false,
  title = "History"
}) => {
  const getHistoryColor = (type) => {
    const colorMap = {
      status_change: "#52c41a",
      comment: "#1890ff",
      field_update: "#faad14",
      created: "#ed017f",
      attachment: "#722ed1",
    };
    return colorMap[type?.toLowerCase()] || "#8c8c8c";
  };

  const formatHistoryItem = (item) => {
    const action = item.action || item.type || "Updated";
    const oldValue = item.oldValue || item.previousValue;
    const newValue = item.newValue || item.value;

    let description = action;
    if (oldValue !== undefined && newValue !== undefined) {
      description = `${action}: ${oldValue} → ${newValue}`;
    } else if (item.content || item.comment) {
      description = item.content || item.comment;
    }

    let userName = "System";
    if (typeof item.user === 'string') {
      userName = item.user;
    } else if (item.user && typeof item.user === 'object') {
      userName = `${item.user.firstName || ''} ${item.user.lastName || ''}`.trim() || item.user.userName || item.user.email || "System";
    } else if (item.userName) {
      userName = item.userName;
    } else if (item.updatedBy) {
      userName = typeof item.updatedBy === 'string' ? item.updatedBy : `${item.updatedBy.firstName || ''} ${item.updatedBy.lastName || ''}`.trim();
    }

    return {
      ...item,
      action: description,
      timestamp: item.timestamp || item.createdAt || item.date,
      userName
    };
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      bodyStyle={{ maxHeight: '400px', overflowY: 'auto' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spin />
        </div>
      ) : history.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
          No History Found
        </div>
      ) : (
        <div className="history-timeline-container">
          {history.map((item, index) => {
            const formattedItem = formatHistoryItem(item);
            return (
              <div key={index} style={{ padding: '4px 0', backgroundColor: '#fcfcfc' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '4px',
                  backgroundColor: 'white',
                  border: '1px solid #d1d1d1',
                  borderRadius: '8px',
                  fontFamily: 'poppins, Arial',
                  fontSize: '11px',
                  padding: '8px',
                  marginTop: '4px'
                }}>
                  {formattedItem.timestamp ? moment(formattedItem.timestamp).format("DD/MM/YYYY HH:mm - ") : ""}
                  {formattedItem.userName} {" "}
                  {formattedItem.message}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default VarianceHistoryModal;
